module.exports = __webpack_public_path__ + "img/43_34.69792100.png";